import React, { memo } from "react"
import { graphql } from "gatsby"

import IndexLayout from "~layouts/IndexLayout"
import ThreeColumnLayout from "~layouts/ThreeColumnLayout"
import Head from "~components/Head"

import Guides from "~components/Guides"

const GuidesPage = ({ data, pageContext }) => (
  <IndexLayout>
    <Head title={pageContext.title} />
    <ThreeColumnLayout alignment="wide">
      <></>
      <Guides guides={data.guides.nodes} showAll title={pageContext.title} />
      <></>
    </ThreeColumnLayout>
  </IndexLayout>
)

export default memo(GuidesPage)

export const query = graphql`
  query {
    guides: allMarkdownRemark(
      filter: {
        frontmatter: {
          is_index: { eq: true }
          hide: { ne: true }
          subcategory_id: { eq: null }
          category_id: { ne: null }
          type: { eq: "guide" }
        }
      }
      sort: {frontmatter: {rank: ASC}}
    ) {
      nodes {
        id
        title
        path
        quickstarts {
          id
          title
          path
        }
        subPages {
          id
          title
          path
        }
        subcategories {
          id
          title
          path
        }
      }
    }
  }
`
